import { render, staticRenderFns } from "./_2.vue?vue&type=template&id=e124b7b4&scoped=true&"
import script from "./_2.vue?vue&type=script&lang=js&"
export * from "./_2.vue?vue&type=script&lang=js&"
import style0 from "./_2.vue?vue&type=style&index=0&id=e124b7b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e124b7b4",
  null
  
)

export default component.exports